import { useMemo } from "react";
import {
  aggregateStatistics,
  formatModelNumber,
} from "../helpers/statisticModelDisplay";
export default function StatisticModelAggregate({ records, en }) {
  const rows = useMemo(() => aggregateStatistics(records), [records]),
    t = (a, b) => (en ? b : a),
    fmt = (n) => formatModelNumber(n, en);
  return (
    <details className="sm-aggregate">
      <summary>
        {t("Aggregierte Statistikkontrolle", "Aggregate statistics check")}
      </summary>
      <p>
        {t(
          "Nur geladene, ausgewertete Fixtures mit vollständigem Wertepaar. Fehler = Actual − Expected. Gesamt = Heim + Auswärts je Fixture; Streuung = Populationsstandardabweichung des Fehlers. Prozentstatistiken: Summen in Prozentpunkten, keine Liga-Ballbesitzquote.",
          "Loaded, evaluated fixtures with a complete value pair only. Error = actual − expected. Total = home + away per fixture; dispersion = population standard deviation of errors. Percentage statistics: sums in percentage points, not league possession percentages."
        )}
      </p>
      <div className="sm-grid">
        <table
          aria-label={t("Aggregierte Statistiken", "Aggregated statistics")}
        >
          <thead>
            <tr>
              {[
                t("Statistik", "Statistic"),
                t("Seite", "Side"),
                "N",
                "Σ Expected",
                "Σ Actual",
                "Δ",
                "Mean Error",
                "Mean Absolute Error",
                t("Streuung", "Dispersion"),
              ].map((x) => (
                <th key={x}>{x}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.flatMap((r) =>
              ["home", "away", "total"].map((side) => (
                <tr key={r.id + side}>
                  <th>
                    {r.title}
                    {r.percent ? " (pp)" : ""}
                  </th>
                  <td>
                    {side === "home"
                      ? t("Heim", "Home")
                      : side === "away"
                      ? t("Auswärts", "Away")
                      : t("Gesamt", "Total")}
                  </td>
                  <td>{r[side].count}</td>
                  {[
                    "expected",
                    "actual",
                    "difference",
                    "mean",
                    "mae",
                    "sd",
                  ].map((k) => (
                    <td key={k}>{fmt(r[side][k])}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </details>
  );
}
